export default () => ({
  wrapper: {
    width: '100%',
    margin: '12px 0',
  },
  label: {
    paddingBottom: 6,
  },
});
